module.exports = require('./ProviderView');